/**
 * Dataset markup for the /data benchmark pages. They publish original
 * numbers, which is what Google Dataset Search and AI answers look for, but
 * shipped no structured data at all (found in the 2026-11-04 audit). Passed
 * to useSeoMeta's jsonLd, the same way /studies marks up its datasets.
 */
import { SITE_URL } from "./brand";

export function datasetJsonLd(o: { title: string; description: string; path: string }) {
  const org = { "@type": "Organization", name: "Indexed", url: SITE_URL };
  return [{
    "@type": "Dataset",
    name: o.title.replace(/\s+[—|-]\s+Indexed( Data)?$/, ""),
    description: o.description,
    url: `${SITE_URL}${o.path}`,
    creator: org,
    publisher: org,
    isAccessibleForFree: true,
    spatialCoverage: "United States",
  }];
}
